import { Check, Minus } from "lucide-react";
import { Reveal, MaskLineInView } from "./Reveal";

const PLANS = ["Basic", "Business", "Premium"];

const ROWS = [
  ["Website", "yes", "yes", "yes"],
  ["Domain", "yes", "yes", "yes"],
  ["Hosting", "yes", "yes", "yes"],
  ["SSL / HTTPS", "yes", "yes", "yes"],
  ["Mobile-Optimierung", "yes", "yes", "yes"],
  ["Kontaktformular", "yes", "yes", "yes"],
  ["Google Maps", "yes", "yes", "yes"],
  ["Website-Umfang", "Onepager", "bis 3 Seiten", "bis 5 Seiten"],
  ["WhatsApp-Integration", "no", "yes", "yes"],
  ["FAQ-Bereich", "no", "yes", "yes"],
  ["Referenzen", "Basis", "yes", "yes"],
  ["Conversion-Optimierung", "Basis", "Erweitert", "Erweitert"],
  ["SEO-Grundoptimierung", "Basis", "Erweitert", "Erweitert"],
  ["Änderungen", "Gelegentlich", "Regelmäßig", "Erweitert"],
  ["Support", "Standard", "Priorisiert", "Höchste Priorität"],
];

function Cell({ v, highlight }) {
  if (v === "yes") return <Check size={18} className={highlight ? "text-[#FF3B00] mx-auto" : "text-[#FF3B00] mx-auto"} />;
  if (v === "no") return <Minus size={18} className="text-neutral-700 mx-auto" />;
  return <span className={`text-sm ${highlight ? "text-white" : "text-neutral-300"}`}>{v}</span>;
}

export default function Comparison() {
  return (
    <section className="relative py-14 lg:py-20 border-t border-white/10" data-testid="comparison">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="max-w-2xl mb-10">
          <Reveal className="font-tech text-xs uppercase tracking-[0.25em] text-[#FF3B00] mb-6 flex items-center gap-3">
            <span className="h-px w-10 bg-[#FF3B00]" /> Pakete im Vergleich
          </Reveal>
          <h2 className="font-display text-4xl md:text-5xl leading-tight tracking-tight text-white uppercase">
            <MaskLineInView>Welches Paket passt</MaskLineInView>
            <MaskLineInView delay={0.1}>zu Ihnen?</MaskLineInView>
          </h2>
        </div>

        {/* Desktop table */}
        <Reveal className="hidden md:block">
          <div className="border border-white/10 overflow-hidden">
            <table className="w-full border-collapse" data-testid="comparison-table">
              <thead>
                <tr className="bg-[#100b07]">
                  <th className="text-left font-tech text-xs uppercase tracking-[0.14em] text-neutral-500 p-5 w-[34%]">Leistung</th>
                  {PLANS.map((p) => (
                    <th
                      key={p}
                      className={`font-display text-xl p-5 text-center ${p === "Business" ? "text-[#FF3B00] bg-[#FF3B00]/[0.06]" : "text-white"}`}
                    >
                      {p}
                      {p === "Business" && <span className="block font-tech text-[10px] uppercase tracking-[0.14em] text-[#FF3B00]">Beliebteste Wahl</span>}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ROWS.map(([label, b, bu, pr], i) => (
                  <tr key={label} className={i % 2 ? "bg-[#0d0a07]" : "bg-transparent"}>
                    <td className="text-neutral-300 text-sm p-5 border-t border-white/5">{label}</td>
                    <td className="p-5 text-center border-t border-white/5"><Cell v={b} /></td>
                    <td className="p-5 text-center border-t border-white/5 bg-[#FF3B00]/[0.04]"><Cell v={bu} highlight /></td>
                    <td className="p-5 text-center border-t border-white/5"><Cell v={pr} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>

        {/* Mobile cards */}
        <div className="md:hidden space-y-5">
          {PLANS.map((p, idx) => (
            <Reveal key={p} delay={idx * 0.05}>
              <div className={`border p-6 ${p === "Business" ? "border-[#FF3B00] bg-[#FF3B00]/[0.05]" : "border-white/10 bg-[#100b07]"}`}>
                <div className="flex items-center justify-between mb-4">
                  <p className="font-display text-xl text-white">{p}</p>
                  {p === "Business" && <span className="font-tech text-[10px] uppercase tracking-[0.14em] text-[#FF3B00]">Beliebteste Wahl</span>}
                </div>
                <ul className="space-y-2.5">
                  {ROWS.map(([label, ...vals]) => {
                    const v = vals[idx];
                    return (
                      <li key={label} className="flex items-center justify-between gap-4 text-sm border-b border-white/5 pb-2.5">
                        <span className="text-neutral-400">{label}</span>
                        <span className="text-right">
                          {v === "yes" ? <Check size={16} className="text-[#FF3B00]" /> : v === "no" ? <Minus size={16} className="text-neutral-700" /> : <span className="text-neutral-200">{v}</span>}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
